import { render, staticRenderFns } from "./formTable.vue?vue&type=template&id=ff5dbffe&scoped=true"
import script from "./formTable.vue?vue&type=script&lang=js"
export * from "./formTable.vue?vue&type=script&lang=js"
import style0 from "./formTable.vue?vue&type=style&index=0&id=ff5dbffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5dbffe",
  null
  
)

export default component.exports